import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/tailwind.pcss'

import firebase from 'firebase/app'
import 'firebase/firestore'

Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: 'AIzaSyCReURC-7WCBVFt2goAUYLU1G-ZdTeQSmI',
  authDomain: 'coursechoicegame.firebaseapp.com',
  projectId: 'coursechoicegame',
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
